import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import { adminMergeConfig } from '@iws/admin-ui-tokens/tailwind-merge'

const twMerge = extendTailwindMerge(adminMergeConfig)

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
